import styled from 'styled-components';

const HolidayManagementWrapper = styled.div`
  .page-header-wrapper {
    padding: 20px 15px;
  }

  .page-title {
    color: #101828;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    margin: 0;
  }

  .holiday-card {
    border: 1px solid #eaecf0;
    box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
    border-radius: 12px;
    margin-bottom: 20px;

    .ant-card-head-title {
      padding: 16px 0;
    }
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .card-title {
    color: #101828;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;

    .anticon {
      font-size: 18px;
      color: #0B2A1B;
    }
  }

  .card-actions {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .year-select {
    min-width: 100px;

    .ant-select-selector {
      border-radius: 8px;
      border-color: #d0d5dd;
    }

    &.ant-select-focused .ant-select-selector {
      border-color: #0B2A1B;
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.1);
    }
  }

  .add-button {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    font-weight: 600;
    border-radius: 8px;
    height: 36px;
  }

  .add-button:hover,
  .add-button:focus {
    background-color: #0d3521;
    border-color: #0d3521;
  }

  .add-button:active {
    background-color: #092116;
    border-color: #092116;
  }

  .stat-card-wrapper {
    height: 100%;

    .ant-card-body {
      padding: 16px;
    }
  }

  .stat-card {
    text-align: center;
    padding: 8px 0;
  }

  .stat-value {
    font-size: 32px;
    font-weight: 600;
    color: #0B2A1B;
    margin-bottom: 8px;
    line-height: 1;
  }

  .stat-label {
    font-size: 14px;
    color: #667085;
    font-weight: 500;
  }

  .holidays-table {
    .ant-table-thead > tr > th {
      background-color: #f9fafb;
      color: #344054;
      font-weight: 600;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .ant-table-tbody > tr > td {
      color: #101828;
    }

    .ant-tag {
      margin-right: 0;
      border-radius: 6px;
      font-weight: 500;
    }
  }

  .holiday-modal {
    .ant-modal-header {
      border-bottom: 1px solid #eaecf0;
    }

    .ant-modal-title {
      color: #101828;
      font-weight: 600;
      font-size: 18px;
    }

    .ant-form-item-label > label {
      color: #344054;
      font-weight: 500;
      font-size: 14px;
    }

    .ant-input,
    .ant-picker {
      border-radius: 8px;
      border-color: #d0d5dd;
    }

    .ant-input:hover,
    .ant-input:focus,
    .ant-picker:hover,
    .ant-picker-focused {
      border-color: #0B2A1B;
    }

    .ant-input:focus,
    .ant-picker-focused {
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.1);
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #0B2A1B;
      border-color: #0B2A1B;
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner {
      border-color: #0B2A1B;
    }
  }

  .submit-button {
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    font-weight: 600;
    border-radius: 8px;
    height: 44px;
  }

  .submit-button:hover,
  .submit-button:focus {
    background-color: #0d3521;
    border-color: #0d3521;
  }

  .submit-button:active {
    background-color: #092116;
    border-color: #092116;
  }

  /* Loading spinner */
  .ant-spin-dot-item {
    background-color: #0B2A1B;
  }

  /* Responsive */
  @media only screen and (max-width: 768px) {
    .page-header-wrapper {
      padding: 15px 10px;
    }

    .page-title {
      font-size: 16px;
    }

    .card-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }

    .card-actions {
      width: 100%;
      flex-direction: column;
      align-items: stretch;

      .year-select,
      .add-button {
        width: 100%;
      }
    }

    .stat-value {
      font-size: 24px;
    }
  }
`;

export default HolidayManagementWrapper;
